import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { loadRuntimeConfig } from './config/runtimeConfig';
import { initAuth } from './config/authConfig';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// 1. Load config from backend → 2. Init MSAL → 3. Render
loadRuntimeConfig()
  .then(() => initAuth())
  .then((msalInstance) => {
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  })
  .catch((err) => {
    root.render(
      <div style={{ padding: 40, fontFamily: 'sans-serif', color: '#c00' }}>
        <h2>Erreur de configuration</h2>
        <p>{err.message}</p>
        <p style={{ color: '#666', fontSize: 14 }}>
          Vérifiez que le backend est démarré et que les variables Azure sont configurées dans le .env backend.
        </p>
      </div>
    );
  });

reportWebVitals();
